export const WorkspaceHazardsStep = () => {
  return <div>Hazards</div>
}
